import {
  APPOINTMENT_CREATE_REQUEST,
  APPOINTMENT_CREATE_SUCCESS,
  APPOINTMENT_CREATE_FAIL,
  APPOINTMENT_LIST_REQUEST,
  APPOINTMENT_LIST_SUCCESS,
  APPOINTMENT_LIST_FAIL,
} from "../../constants/patientConstants/appointmentConstants.js";

const initialState = { appointments: [] };

export const appointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPOINTMENT_CREATE_REQUEST:
    case APPOINTMENT_LIST_REQUEST:
      return { ...state, loading: true };
    case APPOINTMENT_CREATE_SUCCESS:
      return { ...state, loading: false, appointments: [...state.appointments, action.payload] };
    case APPOINTMENT_LIST_SUCCESS:
      return { loading: false, appointments: action.payload };
    case APPOINTMENT_CREATE_FAIL:
    case APPOINTMENT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
